import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import ReactSlider from 'react-slider'
import { useCart } from "../context/UserCartCountContext"
import { discountPrice, getCustomer, isEmptyObj } from "../../include/function"
import { api, baseURL, customerReqConfig } from "../../include/api"
import { useNotification } from "../../Toast/ToastProvider"
import { ERROR, SUCCESS } from "../../include/constant"
import { useLocation } from 'react-router-dom';

const SearchList = ({ categoryList, brandList }) => {
    const location = useLocation();

    let [grid, setGrid] = useState(false)
    let [active, setActive] = useState(false)
    let sidebarController = () => {
        setActive(!active)
    }
    const [productList, setProductList] = useState([]);
    const [fetchLoading, setFetchLoading] = useState(true)
    const customer = getCustomer();
    const [cartData, setCartData] = useState({})
    const { fetchCartCount } = useCart();
    const [priceRange, setPriceRange] = useState([0, 1000]);
    const [filteredList, setFilteredList] = useState([]);
    const [priceLimits, setPriceLimits] = useState({ min: 0, max: 1000 });

    const getCartData = () => {
        if (customer) {
            api.get('/cart/?customerId=' + customer.id, customerReqConfig()).then(response => {
                if (response.status === 200) {
                    setCartData(response.data.data)
                }
            }).catch(error => {
                setCartData([])
            }).finally()
        } else {
            setCartData([])
        }
    }

    const handlePriceFilter = () => {
        const [min, max] = priceRange;
        const filtered = filteredList.filter(p => {
            const price = parseFloat(p.price);
            return price >= min && price <= max;
        });
        setFilteredList(filtered);
    };

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const searchTerm = queryParams.get("q")?.toLowerCase() || "";

        if (!searchTerm) return;

        setFetchLoading(true);
        api.get(`product/?productStatus=active&shopStatus=active`)
            .then(res => {
                const data = res.data.data || [];

                const matched = data.filter(p =>
                    p.name?.toLowerCase().includes(searchTerm)
                );

                setProductList(data);         // all products
                setFilteredList(matched);     // only matched
                const prices = matched.map(p => parseFloat(p.price || 0));
                const min = Math.min(...prices);
                const max = Math.max(...prices);
                setPriceLimits({ min, max });
                setPriceRange([min, max]);
            })
            .catch(() => {
                setProductList([]);
                setFilteredList([]);
            })
            .finally(() => setFetchLoading(false));
    }, [location.search]);

    console.log(filteredList);

    return (
        <section className="shop py-80">
            <div className={`side-overlay ${active && "show"}`}></div>
            <div className="container container-lg">
                <div className="row">
                    <div className="col-lg-3">
                        <div className={`shop-sidebar ${active && "active"}`}>
                            <button onClick={sidebarController}
                                type="button"
                                className="shop-sidebar__close d-lg-none d-flex w-32 h-32 flex-center border border-gray-100 rounded-circle hover-bg-main-600 position-absolute inset-inline-end-0 me-10 mt-8 hover-text-white hover-border-main-600"
                            >
                                <i className="ph ph-x" />
                            </button>
                            <div className="shop-sidebar__box border border-gray-100 rounded-8 p-32 mb-32">
                                <h6 className="text-xl border-bottom border-gray-100 pb-24 mb-24">
                                    Product Category
                                </h6>
                                <ul className="max-h-540 overflow-y-auto scroll-sm">
                                    {
                                        categoryList.map((item, index) => {
                                            const textStyle = "text-gray-900 hover-text-main-600"
                                            return (
                                                <li key={index} className="mb-24">

                                                    <Link
                                                        to={`/category-products/${item.id}`}
                                                        className={textStyle}>

                                                        {item.name}
                                                    </Link>
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                            </div>
                            <div className="shop-sidebar__box border border-gray-100 rounded-8 p-32 mb-32">
                                <h6 className="text-xl border-bottom border-gray-100 pb-24 mb-24">
                                    Filter by Price
                                </h6>
                                <div className="custom--range">
                                    <ReactSlider
                                        className="horizontal-slider"
                                        thumbClassName="example-thumb"
                                        trackClassName="example-track"
                                        value={priceRange}
                                        onChange={value => setPriceRange(value)}
                                        ariaLabel={['Lower thumb', 'Upper thumb']}
                                        renderThumb={(props, state) => <div {...props}>{state.valueNow}</div>}
                                        pearling
                                        minDistance={10}
                                        min={priceLimits.min}
                                        max={priceLimits.max}
                                    />
                                    <br />
                                    <br />
                                    <div className="flex-between flex-wrap-reverse gap-8 mt-24 ">
                                        <button type="button" className="btn btn-main h-40 flex-align" onClick={handlePriceFilter}>
                                            Filter
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="shop-sidebar__box border border-gray-100 rounded-8 p-32 mb-32">
                                <h6 className="text-xl border-bottom border-gray-100 pb-24 mb-24">
                                    Filter by Brand
                                </h6>
                                <ul className="max-h-540 overflow-y-auto scroll-sm">
                                    {
                                        brandList.map((item, index) => {
                                            const textStyle = "text-gray-900 hover-text-main-600"
                                            return (
                                                <li key={index} className="mb-24">

                                                    <Link
                                                        to={`/category-products/${item.id}`}
                                                        className={textStyle}>

                                                        {item.name}
                                                    </Link>
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                            </div>
                            <div className="shop-sidebar__box rounded-8">
                                <img src="assets/images/thumbs/advertise-img1.png" alt="" />
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-9">
                        <div className="flex-between gap-16 flex-wrap mb-40 ">
                            <span className="text-gray-900">Showing {filteredList.length} products</span>
                            <div className="position-relative flex-align gap-16 flex-wrap">
                                <div className="list-grid-btns flex-align gap-16">
                                    <button onClick={() => setGrid(true)}
                                        type="button"
                                        className={`w-44 h-44 flex-center border rounded-6 text-2xl list-btn border-gray-100 ${grid === true && "border-main-600 text-white bg-main-600"}`}
                                    >
                                        <i className="ph-bold ph-list-dashes" />
                                    </button>
                                    <button onClick={() => setGrid(false)}
                                        type="button"
                                        className={`w-44 h-44 flex-center border rounded-6 text-2xl grid-btn border-gray-100 ${grid === false && "border-main-600 text-white bg-main-600"}`}
                                    >
                                        <i className="ph ph-squares-four" />
                                    </button>
                                </div>
                                <div className="position-relative text-gray-500 flex-align gap-4 text-14">
                                    <label htmlFor="sorting" className="text-inherit flex-shrink-0">
                                        Sort by:{" "}
                                    </label>
                                    <select defaultValue={1}
                                        className="form-control common-input px-14 py-14 text-inherit rounded-6 w-auto"
                                        id="sorting"
                                    >
                                        <option value={1} >
                                            Popular
                                        </option>
                                        <option value={1}>Latest</option>
                                        <option value={1}>Trending</option>
                                        <option value={1}>Matches</option>
                                    </select>
                                </div>
                                <button onClick={sidebarController}
                                    type="button"
                                    className="w-44 h-44 d-lg-none d-flex flex-center border border-gray-100 rounded-6 text-2xl sidebar-btn"
                                >
                                    <i className="ph-bold ph-funnel" />
                                </button>
                            </div>
                        </div>
                        <div className={`list-grid-wrapper ${grid && "list-view"}`}>
                            {
                                filteredList?.map((item, index) => {
                                    return (
                                        <Product product={item} key={index} fetchcart={getCartData} fetchCartCount={fetchCartCount} />
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default SearchList;

const Product = ({ product, fetchCartCount, fetchcart }) => {
    const customer = getCustomer();
    const [cartData, setCartData] = useState([])
    const toast = useNotification()
    const navigate = useNavigate();
    const handleAddToCart = (e) => {
        if (!isEmptyObj(customer)) {
            let updatedCartItems = [];
            if (cartData.length > 0) {
                updatedCartItems = [...cartData[0].cartItems];
                const itemIndex = updatedCartItems.findIndex(c => String(c.productId) === String(product.id));
                if (itemIndex !== -1) {
                    updatedCartItems[itemIndex].qty += 1;
                } else {
                    updatedCartItems.push({
                        productId: product.id,
                        qty: 1,
                        price: product.price,
                        discountMode: product.discountMode,
                        discountValue: product.discountValue,
                        deliveryCharge: product.deliveryCharge,
                    });
                }
                let itemsPrice = 0;
                let totalDiscountValue = 0;
                let totalDeliveryCharge = 0;
                updatedCartItems.forEach(item => {
                    const itemTotal = parseFloat(item.price) * item.qty;
                    itemsPrice += itemTotal;

                    let itemDiscount = 0;
                    if (item.discountMode === "percent") {
                        itemDiscount = (parseFloat(item.discountValue) / 100) * itemTotal;
                    } else if (item.discountMode === "amount") {
                        itemDiscount = parseFloat(item.discountValue) * item.qty;
                    }

                    totalDiscountValue += itemDiscount;
                    totalDeliveryCharge += parseFloat(item.deliveryCharge || 0);
                });
                const data = {
                    customerId: cartData[0].customerId,
                    itemsPrice,
                    totalDiscountValue,
                    discountMode: product.discountMode,
                    totalDeliveryCharge,
                    totalPrice: itemsPrice - totalDiscountValue + totalDeliveryCharge,
                    cartItems: updatedCartItems,
                };
                api.put(`/cart/?id=${cartData[0].id}`, data, customerReqConfig())
                    .then(res => {
                        if (res.status === 200) {
                            fetchcart();
                            fetchCartCount();
                            toast({ type: SUCCESS, message: res.data.message });
                        }
                    }).catch(err => {
                        toast({ type: ERROR, message: err?.response?.data?.message || err.message });
                    });

            } else {
                const itemTotal = parseFloat(product.price);
                const itemDiscount = product.discountMode === 'percent'
                    ? (parseFloat(product.discountValue) / 100) * itemTotal
                    : parseFloat(product.discountValue || 0);

                const delivery = parseFloat(product.deliveryCharge || 0);
                const data = {
                    customerId: customer.id,
                    itemsPrice: itemTotal,
                    totalDiscountValue: itemDiscount,
                    discountMode: product.discountMode,
                    totalDeliveryCharge: delivery,
                    totalPrice: itemTotal - itemDiscount + delivery,
                    cartItems: [
                        {
                            productId: product.id,
                            qty: 1,
                            price: product.price,
                            discountMode: product.discountMode,
                            discountValue: product.discountValue,
                            deliveryCharge: product.deliveryCharge,
                        }
                    ]
                };
                api.post('/cart/', data, customerReqConfig())
                    .then(res => {
                        if (res.status === 200) {
                            fetchcart();
                            fetchCartCount();
                            toast({ type: SUCCESS, message: res.data.message });
                        }
                    }).catch(err => {
                        toast({ type: ERROR, message: err?.response?.data?.message || err.message });
                    });
            }
        } else {
            navigate('/login');
        }
    };
    useEffect(() => {
        if (customer?.id) {
            api.get(`/cart/?customerId=${customer.id}`, customerReqConfig())
                .then(res => {
                    setCartData(res.data.data || []);
                })
                .catch(() => setCartData([]));
        }
    }, []);
    return (
        <div className="product-card h-100 p-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
            <Link
                to={`/product-details/${product.id}`}
                className="product-card__thumb flex-center rounded-8 bg-gray-50 position-relative"
            >
                <img
                    src={baseURL + "/" + product.mainImage}
                    alt=""
                    className="w-auto max-w-unset"
                />
                {product.discountLabel &&
                    <span className="product-card__badge bg-primary-600 px-8 py-4 text-sm text-white position-absolute inset-inline-start-0 inset-block-start-0">
                        {product.discountLabel}{" "}
                    </span>
                }

            </Link>
            <div className="product-card__content mt-16">
                <h6 className="title text-lg fw-semibold mt-12 mb-8">
                    <Link
                        to={`/product-details/${product.id}`}
                        className="link text-line-2"
                        tabIndex={0}
                    >
                        {product.name}
                    </Link>
                </h6>
                <div className="flex-align mb-20 mt-16 gap-6">
                    <span className="text-xs fw-medium text-gray-500">{product.rating}</span>
                    <span className="text-15 fw-medium text-warning-600 d-flex">
                        <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-medium text-gray-500">({product.ratingAndReview?.length})</span>
                </div>
                <div className="mt-8">
                    <div
                        className="progress w-100 bg-color-three rounded-pill h-4"
                        role="progressbar"
                        aria-label="Basic example"
                        aria-valuenow={35}
                        aria-valuemin={0}
                        aria-valuemax={100}
                    >
                        <div
                            className="progress-bar bg-main-two-600 rounded-pill"
                            style={{ width: "35%" }}
                        />
                    </div>
                    <span className="text-gray-900 text-xs fw-medium mt-8">
                        Sold: 18/35
                    </span>
                </div>
                <div className="product-card__price my-20">

                    <span className="text-heading text-md fw-semibold ">
                        ₹ {product.price.toFixed(2)} <span className="text-gray-500 fw-normal">/Qty</span>{" "}
                    </span>
                </div>
                <button
                    className='btn btn-main-two rounded-8 px-64'
                    onClick={handleAddToCart}
                >
                    Add To Cart <i className='ph ph-shopping-cart' />
                </button>
            </div>
        </div >
    )
}